import { Stack, Typography } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

import { errorMessageFor } from 'utils/forms.utils';

import FormCountryPicker from 'components/@forms/FormCountryPicker';
import FormTextField from 'components/@forms/FormTextField';

const AddressForm = () => {
  const intl = useIntl();

  return (
    <Stack
      sx={{
        gap: 1,
        flexGrow: { xs: 1, md: 0 },
      }}
    >
      <Typography
        variant="small"
        sx={{
          fontWeight: 'bold',
          color: 'text.secondary',
        }}
      >
        <FormattedMessage id="account.address.title" />
      </Typography>
      <FormCountryPicker
        label={<FormattedMessage id="form.label.country" />}
        name="countryCode"
        rules={{
          required: errorMessageFor(intl, {
            type: 'required',
            label: 'country',
          }),

          validate: (value: string) =>
            value.trim().length > 0 ||
            errorMessageFor(intl, {
              type: 'required',
              label: 'country',
            }),
        }}
      />
      <FormTextField
        label={<FormattedMessage id="form.label.address_line_1" />}
        rules={{
          required: errorMessageFor(intl, {
            type: 'required',
            label: 'address_line_1',
          }),
          maxLength: {
            value: 200,
            message: errorMessageFor(intl, {
              type: 'max_length',
              label: 'address_line_1',
              value: 200,
            }),
          },
          validate: (value: string) =>
            value.trim().length > 0 ||
            errorMessageFor(intl, {
              type: 'required',
              label: 'address_line_1',
            }),
        }}
        name="address1"
        type="text"
        inputMode="text"
        autoComplete="address-line1"
      />
      <FormTextField
        label={<FormattedMessage id="form.label.address_line_2" />}
        name="address2"
        type="text"
        inputMode="text"
        autoComplete="address-line2"
        rules={{
          maxLength: {
            value: 200,
            message: errorMessageFor(intl, {
              type: 'max_length',
              label: 'address_line_2',
              value: 200,
            }),
          },
        }}
      />
      <FormTextField
        label={<FormattedMessage id="form.label.zip" />}
        rules={{
          maxLength: {
            value: 50,
            message: errorMessageFor(intl, {
              type: 'max_length',
              label: 'zip',
              value: 50,
            }),
          },
          required: errorMessageFor(intl, {
            type: 'required',
            label: 'zip',
          }),
        }}
        name="postalCode"
        type="text"
        inputMode="text"
        autoComplete="postal-code"
      />
      <FormTextField
        label={<FormattedMessage id="form.label.city" />}
        rules={{
          maxLength: {
            value: 50,
            message: errorMessageFor(intl, {
              type: 'max_length',
              label: 'city',
              value: 50,
            }),
          },
          required: errorMessageFor(intl, {
            type: 'required',
            label: 'city',
          }),

          validate: (value: string) =>
            value.trim().length > 0 ||
            errorMessageFor(intl, {
              type: 'required',
              label: 'city',
            }),
        }}
        name="city"
        type="text"
        inputMode="text"
      />
    </Stack>
  );
};

export default AddressForm;
